import { render, staticRenderFns } from "./PleurisyAssumptionReport.vue?vue&type=template&id=97864258&scoped=true&"
import script from "./PleurisyAssumptionReport.vue?vue&type=script&lang=ts&"
export * from "./PleurisyAssumptionReport.vue?vue&type=script&lang=ts&"
import style0 from "./PleurisyAssumptionReport.vue?vue&type=style&index=0&id=97864258&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97864258",
  null
  
)

export default component.exports